export const langZH = {
  'nav': {
    'hello': '您好，欢迎光临智游迁安！',
    'classification': '全部分类',
    'login': '登录',
    'register': '注册',
    'personalCenter': '个人中心',
    'logOut': '退出登录',
    'shoppingCart': '购物车',
    'search': '输入你想查找的商家',
    'conNumber': '联系电话',
  },
  'footer': {
    'fifteen': '©泰和数潮(唐山)科技有限公司（taiheshuchao.com）营业执照',
    'sixteen': '冀ICP备15016998号-3',
    'eighteen': '违法和不良信息举报电话：4006561155',
    'nineteen': '消费者维权热线：4006067733',
    'twenty': '点击验照'
  },
  'personalCenter': {
    'personal': '个人中心',
    'personalInformation': '个人信息',
    'myOrder': '我的订单',
    'commonInformation': '常用信息',
    'myFocus': '我的关注',
    'AfterSalesService': '售后服务',
    'myAccount': '我的钱包',
    'guideCenter': '导游中心',
    'guideApplication': '导游申请',
    'myCollection': '我的收藏',
    'coupon': '优惠券',
    'Essentialinformation': '基本信息',
    'nickname': '昵称',
    'Pleasenickname': '请输入昵称',
    'username': '用户名',
    'enterusername': '请输入用户名',
    'Gender': '性别',
    'male': '男',
    'female': '女',
    'Submit': '提交',
    'Reset': '重置',
    'Myorder': '我的订单',
    'Noorderbeing': '暂时没有订单',
    'amount': '金额',
    'Commoditydiscount': '商品优惠',
    'Couponoffset': '优惠券抵',
    'status': '状态',
    'operation': '操作',
    'copewith': '应付',
    'Paid': '已支付',
    'Immediatepayment': '立即支付',
    'Onlinepayment': '线上支付',
    'orderId': '订单号',
    'orderDetail': '订单详情',
    'Topay': '去付款',
    'cancellationoforder': '取消订单',
    'Deleteorder': '删除订单',
    'Addshippingaddress': '添加收货地址',
    'Defaultaddress': '默认地址',
    'consignee': '收货人',
    'Consigneeinformation': '收货人信息',
    'Deliveryinformation': '配送信息',
    'Deliverymethod': '配送方式',
    'Pickitupatthestore': '到店自取',
    'Responsiblemerchants': '负责商家',
    'orderType': '订单类型',
    'remarks': '备注',
    'Paymentinformation': '付款信息',
    'paymentmethod': '付款方式',
    'orderTime': '下单时间',
    'Totalgoods': '商品总额',
    'Preferentialamount': '优惠金额',
    'Amountpayable': '应支付金额',
    'Orderstatus': '订单状态',
    'Applyforrefund': '申请退款',
    'Confirmreceipts': '确认收货',
    'Location': '所在地区',
    'address': '地址',
    'phone': '手机',
    'fixedtelephone': '固定电话',
    'E-mail': '电子邮箱',
    'name': '姓名',
    'IDnumber': '身份证号',
    'Setasdefault': '设为默认',
    'Receivingaddress': '收货地址',
    'Receivingregion': '收件地区',
    'Touristinformation':'游客信息',
    'addTouristinformation':'添加游客信息',
    'Favoritestore':'收藏的店铺',
    'Favoriteitems':'收藏的商品',
    'Enterthestore':'进入店铺',
    'Productdetails':'商品详情',
    'after-saleservice':'售后服务',
    'contactinformation':'联系方式',
    'Mywallet':'我的钱包',
    'Walletlog':'钱包日志',
    'Mychange':'我的零钱',
    'Recharge':'充值',
    'Withdrawal':'提现',
    'Norechargerecordtemporarily':'暂无充值记录',
    'TourguideCenter':'导游中心',
    'Restrecord':'休息记录',
    'Attendancemanagement':'考勤管理',
    'Nameoftourguide':'导游名称',
    'Personalsignature':'个性签名',
    'Totalorderquantity':'总订单量',
    'Totaltransactionamount':'总交易金额',
    'Amounttobesettled':'待结算金额',
    'Tourguideorderlist':'导游订单列表',
    'Notourguideorderyet':'暂无导游订单',
    'Orderamount':'订单金额',
    'Checkorderornot':'是否验单',
    'Unverifiedorder':'未验单',
    'Checkedlist':'已验单',
    'Tourguidesettlementlist':'导游结算列表',
    'notourguide':'暂无导游结算单',
    'SettlementNo':'结算单号',
    'Settlementperiod':'结算周期',
    'Settlementamount':'结算金额',
    'Settlementstatus':'结算状态',
    'Settlementdetails':'结算明细',
    'noproblem':'没有问题',
    'somethingthematter':'有问题',
    'Confirmreceipt':'确认收款',
    'Mycoupons':'我的优惠券',
    'termofvalidity':'有效期',
    'Touse':'去使用',
    'whole':'全部',
    'Received':'已领取',
    'Couponsavailable':'可使用优惠券',
    'full':'满',
    'Used':'已使用',
    'nocoupons':'暂无优惠券,赶快去领取吧',
  },
  'shopCar': {
    'allProducts': '全部商品',
    'noShopCar': '您的购物车没有商品，请先添加商品到购物车再点击购买',
    'productName': '商品名称',
    'productPicture': '商品图片',
    'specification': '规格',
    'unitPrice': '单价',
    'number': '数量',
    'totalPrice': '总价',
    'operation': '操作',
    'batchDelete': '批量删除',
    'settleAccount': '结算',
    'delete': '确定删除该商品吗?',
    'deleteYes': '确定',
    'deleteNo': '取消',
    'selectDelete': '请选择要删除的商品',
    'panel': '板块',
    'classification': '分类',
    'exist': '抱歉，搜索内容不存在',
  },
  'product': {
    'one': '商品列表',
    'two': '该商家暂无商品出售，改天再来看看吧~',
    'three': '立即购买',
    'favorite': '收藏商品',
    'collected': '已收藏',
    'price': '价格',
    'quantity': '数量',
    'stock': '库存',
    'jian': '件',
    'addCar': '加入购物车',
    'details': '商品详情',
    'evaluation': '累计评价',
    'Q&A': '商品问答',
    'name': '公司名称',
    'address': '所在地',
    'lianxi': '联系客服',
    'merchant': '进入店铺',
    'scdp': '收藏店铺',
    'evaluationList': '该商品暂无评价'
  },
  'operate': {
    'see': '查看更多',
    'address': '地址',
    'qualifications': '商家资质',
    'xing': '星',
    'sold': '已售',
    'praise': '好评',
    'begin': '起',
    'Money':'￥'
  },
  'pay': {
    'address': '选择收货地址',
    'payment': '支付方式',
    'confirm': '确认订单信息',
    'one': '商品',
    'tow': '商品属性',
    'three': '单价',
    'four': '数量',
    'five': '小计',
    'six': '确认付款',
    'seven': '收货人',
    'Managereceivingaddress': '管理收货地址',
    'eight': '默认地址'
  },
  'qrcode': {
    'one': '扫码支付',
    'two': '总价格',
    'three': '优惠金额',
    'four': '实际支付',
    'five': '请在十分钟之内完成支付，否则订单自动取消',
    'six': '取消'
  }
}



// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js